/* Lumina Nail Growth Oil — landing interactivity (adapted from Claude Design export for Shopify) */
(function () {
  if (window.__luminaLandingInit) return;   // safe on multiple templates
  window.__luminaLandingInit = true;

  function init() {
    /* ---------- Gallery carousel (arrows + thumbs + swipe) ---------- */
    (function () {
      var carousel = document.getElementById('lumGalMain');
      var track = document.getElementById('lumGalTrack');
      if (!carousel || !track) return;
      var slides = track.children.length;
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.lum-buy .g-thumb'));
      var dots = Array.prototype.slice.call(document.querySelectorAll('.lum-buy .g-dot'));
      var arrowL = document.getElementById('lumGalPrev');
      var arrowR = document.getElementById('lumGalNext');
      var idx = 0;

      function render(offsetPx) {
        var w = carousel.getBoundingClientRect().width;
        track.style.transform = 'translateX(' + (-idx * w + (offsetPx || 0)) + 'px)';
        thumbs.forEach(function (t, n) { t.classList.toggle('active', n === idx); });
        dots.forEach(function (d, n) { d.classList.toggle('active', n === idx); });
      }
      function go(n) { idx = Math.max(0, Math.min(slides - 1, n)); render(0); }

      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
      if (arrowL) arrowL.addEventListener('click', function () { go(idx - 1); });
      if (arrowR) arrowR.addEventListener('click', function () { go(idx + 1); });

      var startX = 0, dx = 0, dragging = false, moved = false;
      function down(e) { dragging = true; moved = false; startX = (e.touches ? e.touches[0].clientX : e.clientX); track.classList.add('dragging'); }
      function move(e) { if (!dragging) return; var x = (e.touches ? e.touches[0].clientX : e.clientX); dx = x - startX; if (Math.abs(dx) > 6) moved = true; render(dx); }
      function up() { if (!dragging) return; dragging = false; track.classList.remove('dragging'); var w = carousel.getBoundingClientRect().width; if (dx < -w * 0.18) idx = Math.min(slides - 1, idx + 1); else if (dx > w * 0.18) idx = Math.max(0, idx - 1); dx = 0; render(0); }
      track.addEventListener('mousedown', down);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', up);
      track.addEventListener('touchstart', down, { passive: true });
      track.addEventListener('touchmove', move, { passive: true });
      track.addEventListener('touchend', up);
      window.addEventListener('resize', function () { render(0); });
      render(0);
    })();

    /* ---------- Plan selector (visual state; ATC reads data-qty / data-variant-id) ---------- */
    var plans = Array.prototype.slice.call(document.querySelectorAll('.lum-buy .plan'));
    if (plans.length) {
      plans.forEach(function (p) {
        p.addEventListener('click', function () {
          plans.forEach(function (x) { x.classList.remove('is-selected'); });
          p.classList.add('is-selected');
          var vid = p.getAttribute('data-variant-id');
          if (vid) {
            document.querySelectorAll('[data-lumina-atc]').forEach(function (b) { b.setAttribute('data-variant-id', vid); });
          }
        });
      });
      // on load, sync the ATC variant to the pre-selected plan (so it matches what's highlighted)
      var preSel = document.querySelector('.lum-buy .plan.is-selected[data-variant-id]');
      if (preSel) {
        var pv = preSel.getAttribute('data-variant-id');
        document.querySelectorAll('[data-lumina-atc]').forEach(function (b) { b.setAttribute('data-variant-id', pv); });
      }
    }

    /* ---------- Accordions (buy-box "acc-item" + FAQ "faq-item") ---------- */
    function wireAccordion(qSel, itemSel) {
      document.querySelectorAll(qSel).forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest(itemSel);
          var open = item.classList.contains('open');
          var container = item.parentElement;
          container.querySelectorAll(itemSel + '.open').forEach(function (it) {
            if (it !== item) { it.classList.remove('open'); var p = it.querySelector('.pm'); if (p) p.textContent = '+'; }
          });
          item.classList.toggle('open', !open);
          var pm = q.querySelector('.pm');
          if (pm) pm.textContent = open ? '+' : '−';
        });
      });
    }
    wireAccordion('.lum-acc .acc-q', '.acc-item');
    wireAccordion('.lum-faq .faq-q', '.faq-item');

    /* ---------- Sticky offer bar: reveal after hero + countdown timer ---------- */
    var bar = document.getElementById('lumStickyBar');
    if (bar) {
      var anchor = document.querySelector('.lum-hero') || document.querySelector('.lum-buy');
      if (anchor) {
        window.addEventListener('scroll', function () {
          var past = anchor.getBoundingClientRect().bottom < 0;
          var nearFooter = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 360);
          bar.classList.toggle('show', past && !nearFooter);
        }, { passive: true });
      }
      var hoursAttr = parseInt(bar.getAttribute('data-hours'), 10);
      var hours = (hoursAttr && hoursAttr > 0) ? hoursAttr : 24;
      var hEl = document.getElementById('lumHrs'), mEl = document.getElementById('lumMin'), sEl = document.getElementById('lumSec');
      if (hEl && mEl && sEl) {
        var end = Number(localStorage.getItem('lumina_offer_end'));
        var now = Date.now();
        if (!end || end < now) { end = now + hours * 3600 * 1000; localStorage.setItem('lumina_offer_end', String(end)); }
        var pad = function (n) { return String(n).padStart(2, '0'); };
        var tick = function () {
          var d = Math.max(0, end - Date.now());
          var h = Math.floor(d / 3600000); d -= h * 3600000;
          var m = Math.floor(d / 60000); d -= m * 60000;
          var s = Math.floor(d / 1000);
          hEl.textContent = pad(h); mEl.textContent = pad(m); sEl.textContent = pad(s);
        };
        tick();
        setInterval(tick, 1000);
      }
    }

    /* ---------- Add to cart (buy-box ONLY) ----------
       Bound to [data-lumina-atc]. Every other CTA is a plain <a href="#lumina-buy">. */
    document.querySelectorAll('[data-lumina-atc]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var vid = b.getAttribute('data-variant-id');
        var label = b.querySelector('span') || b;
        var orig = label.textContent;
        if (!vid) {   // no product wired yet -> visual feedback only
          e.preventDefault();
          label.textContent = 'Added ✓';
          setTimeout(function () { label.textContent = orig; }, 1400);
          return;
        }
        e.preventDefault();
        var sel = document.querySelector('.lum-buy .plan.is-selected');
        var qty = sel ? (parseInt(sel.getAttribute('data-qty'), 10) || 1) : 1;
        label.textContent = 'Adding…';
        // Open the theme's cart drawer (Dawn/Elixir <cart-drawer>) instead of redirecting.
        var cartDrawer = document.querySelector('cart-drawer');
        var sectionIds = (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function')
          ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
        var body = { items: [{ id: Number(vid), quantity: qty }] };
        if (sectionIds.length) { body.sections = sectionIds; body.sections_url = window.location.pathname; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (response) {
          if (response && response.status && !response.id) { label.textContent = orig; return; } // add error
          label.textContent = 'Added ✓';
          setTimeout(function () { label.textContent = orig; }, 1600);
          try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true })); } catch (err) {}
          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && response.sections) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(response);
          } else {
            window.location.href = '/cart'; // fallback for themes without a drawer
          }
        }).catch(function () { label.textContent = orig; });
      });
    });

    /* ---------- Testimonials "Load more" ---------- */
    document.querySelectorAll('[data-testi-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var scope = btn.closest('.lum-testi') || document;
        scope.querySelectorAll('.card.is-hidden').forEach(function (c) { c.classList.remove('is-hidden'); });
        btn.style.display = 'none';
      });
    });

    /* ---------- Results rings (animate on scroll) ---------- */
    var resultsList = document.getElementById('luminaResults');
    if (resultsList && 'IntersectionObserver' in window) {
      var CIRC = 2 * Math.PI * 34; // r = 34
      var animated = false;
      resultsList.querySelectorAll('.ring-num').forEach(function (n) { n.textContent = '0%'; });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && !animated) {
            animated = true;
            resultsList.querySelectorAll('.result-row').forEach(function (row, i) {
              var pct = parseInt(row.getAttribute('data-pct'), 10) || 0;
              var fg = row.querySelector('.ring-fg');
              var num = row.querySelector('.ring-num');
              setTimeout(function () {
                if (fg) fg.style.strokeDashoffset = (CIRC * (1 - pct / 100)).toFixed(1);
                var start = Date.now();
                var tick = setInterval(function () {
                  var t = Math.min(1, (Date.now() - start) / 1300);
                  var val = Math.round(pct * (1 - Math.pow(1 - t, 3)));
                  if (num) num.textContent = val + '%';
                  if (t >= 1) clearInterval(tick);
                }, 30);
              }, i * 180);
            });
          }
        });
      }, { threshold: 0.2 });
      obs.observe(resultsList);
    }

    /* ---------- Reviews pagination (visual) ---------- */
    document.querySelectorAll('.lum-reviews .pagination button').forEach(function (b) {
      b.addEventListener('click', function () {
        document.querySelectorAll('.lum-reviews .pagination button').forEach(function (x) { x.classList.remove('active'); });
        if (!b.hasAttribute('data-nav')) b.classList.add('active');
        var rl = document.querySelector('.lum-reviews .list');
        if (rl) window.scrollTo({ top: rl.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
